let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("8NX0R"), load("jR5cZ")]).then(() => parcelRequire('37034'));